import { configureStore } from '@reduxjs/toolkit';
import showCookies from '@/state/showCookiesSlice';
import menu from '@/state/menuSlice';
import modal from '@/state/modalSlice';

export default configureStore({
	reducer: {
		showCookies,
		menu,
		modal,
	},
});
